import React, { FC } from 'react';
import Svg from 'svg-inline-react';
import classnames from 'classnames';
import { useOpeningForConnectButtonLazyQuery } from '@src/graphql/generated';
import FrChatSvg from '@src/svgs/fr-chat-small.svg';
import { ConnectProps } from './props';

export const Connect: FC<ConnectProps> = ({
  activeOpeningId,
  buttonClassName,
  isButtonIconHidden,
  onConfirmTalent,
}) => {
  const [fetchOpening] = useOpeningForConnectButtonLazyQuery();

  const onConfirmClick = async (): Promise<void> => {
    if (activeOpeningId) {
      const { data } = await fetchOpening({
        variables: {
          id: activeOpeningId,
        },
      });

      onConfirmTalent({
        openingId: activeOpeningId,
        openingTitle: data?.opening.title,
        pitch: data?.opening.pitch,
      });

      return;
    }

    onConfirmTalent();
  };

  return (
    <div className={classnames('connect-hide-actions__confirm', buttonClassName)} onClick={onConfirmClick}>
      {!isButtonIconHidden && (
        <Svg className="connect-hide-actions__action-icon connect-hide-actions__action-icon--confirm" src={FrChatSvg} />
      )}
      Contact me
    </div>
  );
};
